<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="rruleDates != null && rruleDates.length > 0" class="flex flex-col gap-3 h-full">
    <div class="flex items-center gap-2 shrink-0">
      <i class="pi pi-calendar text-lg text-primary"></i>
      <span class="font-semibold text-base">{{ rruleText | titlecase }}</span>
    </div>

    <div *ngIf="!hasEnd" class="text-sm text-muted-color shrink-0">
      Showing next 10 occurrences
    </div>

    <app-ag-grid class="flex-1 min-h-0" [gridOptions]="rruleGridOptions" [rowData]="rruleDates" [hasFooter]="false">
    </app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <button pButton type="button" class="p-button-raised" (click)="ok()">
    <span>Close</span>
  </button>
</ng-template>
